import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconContactCustomerSupport = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => {
    return (
        <div className="icon-block">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                fill="none"
                viewBox="0 0 16 17"
                >
                <g clipPath="url(#clip0_31252_24465)">
                    <path fill={color} d="M8 2.215c-3.59 0-6.5 2.91-6.5 6.5v1.25c0 .415-.334.75-.75.75a.748.748 0 01-.75-.75v-1.25a8 8 0 018-8 8 8 0 018 8v4.503a2.75 2.75 0 01-2.753 2.75L9.8 15.965c-.26.447-.744.75-1.3.75h-1a1.5 1.5 0 010-3h1c.556 0 1.04.303 1.3.75l3.45.003c.69 0 1.25-.56 1.25-1.25V8.715c0-3.59-2.91-6.5-6.5-6.5zm-3.5 5H5c.553 0 1 .447 1 1v3.5c0 .553-.447 1-1 1h-.5c-1.103 0-2-.897-2-2v-1.5c0-1.103.897-2 2-2zm7 0c1.103 0 2 .897 2 2v1.5c0 1.103-.897 2-2 2H11c-.553 0-1-.447-1-1v-3.5c0-.553.447-1 1-1h.5z"></path>
                </g>
                <defs>
                    <clipPath id="clip0_31252_24465">
                    <path
                        fill="#fff"
                        d="M0 0H16V16H0z"
                        transform="translate(0 .715)"
                    ></path>
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
}

export default IconContactCustomerSupport;
